import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataHelper } from '@app/helpers/data.helper';
import { UiHelper } from '@app/helpers/ui.helper';
import { ApiService } from '@app/services/api.service';
import { LocalizationService } from '@services/localization.service';
import { GroupedDataItem } from '@app/models/mostTicket.model';
@Component({
  selector: 'ticket-detail-modal-component',
  templateUrl: './ticket-detail-modal.component.html',
})
export class ticketDetailModalComponent {
  ticketData: GroupedDataItem;
  tickets: GroupedDataItem[];
  currentIndex: number;
  maxIndex: number;
  translateValue = 0;

  STAKE_AMOUNT = 10;

  @ViewChild('slideElem', { read: ElementRef })
  slideElem: ElementRef;
  constructor(
    public dialogRef: MatDialogRef<ticketDetailModalComponent>,
    public _DataHelper: DataHelper,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _ApiHelper: ApiService,
    public _LocalizationService: LocalizationService,
    public _UiHelper: UiHelper
  ) {
    this.currentIndex = data.index;
    if (this._DataHelper.mostPlayedTicketData && this._DataHelper.mostPlayedTicketData.length > 0) {
      this.maxIndex = this._DataHelper.mostPlayedTicketData.length - 1;
      this.ticketData = this._DataHelper.mostPlayedTicketData[this.currentIndex];
    }
    this.tickets = this._DataHelper.mostPlayedTicketData;
    this.reBuildData();
  }

  nextItem(): void {
    if (this.currentIndex < this.maxIndex) {
      this.currentIndex++;
      this.translateValue -= 100;
    }
  }

  prevItem(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.translateValue += 100;
    }
  }

  closeModal(): void {
    this.dialogRef.close();
  }
  reBuildData() {
    this.ticketData?.data.forEach((element, index) => {
      const eventName = element.EventName.split('-');
      if (eventName && Array.isArray(eventName) && eventName.length === 2) {
        element.HomeTeam = eventName[0];
        element.AwayTeam = eventName[1];
      }
    });
  }

  checkOddId(oddId) {
    const index = this._ApiHelper.slipCurrents.findIndex(v => {
      return v.OddId1 == oddId;
    });
    if (index > -1) {
      return 'active';
    } else {
      return '';
    }
  }

  clickNewOdd(e) {
    const _market = e.OddsType;
    let _betType = 0;

    // 07-03-2022 - SpecialBetValue Parantez kaldırıldı. Sebebi : İlk data da Parantezli geliyordu. Sonra refresh olunca gidiyordu parantez !
    // 07-03-2022 - Soccer için specialIsActive eklendi. Böylece Data ilk geldiğinde SpecialBetValue olmadığında Score gösterilmiş oldu !
    const newOdd = {
      Banko: false,
      BetType: _betType,
      Enable: true,
      EventDateLong: e.EventDate,
      EventName: e.EventName,
      MatchId: e.MatchId,
      OddId1: e.OddId,
      OddsType: _market,
      OddsTypeId: e.OddsTypeId,
      OddValue1: e.OddValue,
      OutCome: e.Outcomes,
      ShortOddType: _market,
      SpecialBetValue: e.SpecialBetValue,
      Visibility: '',
      HomeTeam: e.EventName?.split('-')[0],
      AwayTeam: e.EventName?.split('-')[1],
    };
    this._DataHelper.currentSlipInfo.currentslip_totalStake = this.STAKE_AMOUNT;
    this._ApiHelper.addOddDirectly(newOdd);
  }

  placeAllTicket() {
    // Data da odd bilgileri yok a da odd bilgileri verilirse yapının çalışması gerekiyor.
    this.ticketData?.data.forEach(e => {
      const _market = e.OddsType;
      let _betType = 0;

      // 07-03-2022 - SpecialBetValue Parantez kaldırıldı. Sebebi : İlk data da Parantezli geliyordu. Sonra refresh olunca gidiyordu parantez !
      // 07-03-2022 - Soccer için specialIsActive eklendi. Böylece Data ilk geldiğinde SpecialBetValue olmadığında Score gösterilmiş oldu !
      const newOdd = {
        Banko: false,
        BetType: _betType,
        Enable: true,
        EventDateLong: e.EventDate,
        EventName: e.EventName,
        MatchId: e.MatchId,
        OddId1: e.OddId,
        OddsType: _market,
        OddsTypeId: e.OddsTypeId,
        OddValue1: e.OddValue,
        OutCome: e.Outcomes,
        ShortOddType: _market,
        SpecialBetValue: e.SpecialBetValue,
        Visibility: '',
        HomeTeam: e.HomeTeam,
        AwayTeam: e.AwayTeam,
      };
      this._DataHelper.currentSlipInfo.currentslip_totalStake = this.STAKE_AMOUNT;
      this._ApiHelper.addOddDirectly(newOdd);
      this.closeModal();

      this._UiHelper.closeAllMenus();
      this._UiHelper.p1001SetMatchDetailDialog('close');
      this._UiHelper.p1001SetBottomDialogState('open');
    });
  }
}
